// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"Loader_text-gradient__1xCk2","loader":"Loader_loader__2hZcM","loaderWhite":"Loader_loaderWhite__15qL9","loader-white":"Loader_loader-white__1Y66o"};